import React, { useState, useEffect } from 'react';
import { updateConsent, hasRespondedToConsent } from '../utils/consent';

export const ConsentBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show if the user hasn't responded yet
    if (!hasRespondedToConsent()) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    updateConsent(true);
    setIsVisible(false);
  };

  const handleDecline = () => {
    updateConsent(false);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-zinc-900 border-t border-zinc-800 p-4 md:p-6 shadow-2xl transition-transform duration-500 transform translate-y-0">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-zinc-300 text-sm md:text-base flex-1">
          <h3 className="text-white font-bold mb-1">We respect your privacy</h3>
          <p>
            We use cookies and similar technologies to measure our performance and improve your experience. You can choose to accept or decline analytics and advertising tracking.
          </p>
        </div>
        <div className="flex flex-row gap-3 w-full md:w-auto shrink-0">
          <button 
            onClick={handleDecline}
            className="flex-1 md:flex-none px-4 py-2 rounded-lg bg-transparent border border-zinc-600 text-zinc-300 hover:bg-zinc-800 transition-colors font-medium whitespace-nowrap"
          >
            Decline All
          </button>
          <button 
            onClick={handleAccept}
            className="flex-1 md:flex-none px-4 py-2 rounded-lg bg-v2-neon text-black hover:bg-v2-neon-hover transition-colors font-bold whitespace-nowrap shadow-[0_0_15px_rgba(200,255,0,0.3)]"
          >
            Accept Cookies
          </button>
        </div>
      </div>
    </div>
  );
};
